import { FormGroup, Input } from '@starsoft/common/components';
import styles from '../styles.module.scss';
import skeletonStyles from './styles.module.scss';
import { useSearchParams } from '@starsoft/common/hooks';
import UserPhoneNumberFormVerifySkeleton from '../Verify/Skeleton';

export default function UserPhoneNumberFormSkeleton() {
  const search: URLSearchParams = useSearchParams();
  const phoneNumberId: string | undefined = search.get('phone-number-id');

  return (
    <div className={styles.container}>
      <div className={styles.container__content}>
        <div className={skeletonStyles['lottie-skeleton']} />
        <div className={skeletonStyles['text-column']}>
          {Array.from({ length: 2 }).map((_, index) => (
            <div
              key={`text-skeleton-${index}`}
              className={skeletonStyles['text-skeleton']}
            />
          ))}
        </div>

        {!!phoneNumberId ? (
          <UserPhoneNumberFormVerifySkeleton />
        ) : (
          <div className={styles.container__row}>
            <FormGroup
              loading={{
                label: true,
              }}
              isLoading
            >
              <Input isLoading />
            </FormGroup>
            <FormGroup
              loading={{
                label: true,
              }}
              isLoading
            >
              <Input isLoading />
            </FormGroup>
          </div>
        )}
      </div>

      <div
        className={`${styles.container__button} ${!!phoneNumberId ? styles['container__button--verify'] : ''}`}
      >
        <Input isLoading />
      </div>
    </div>
  );
}
